<template>
    <el-aside :style="{width: collapsed?'60px':'256px'}">
        <el-scrollbar style="height: calc(100% - 41px)">
            <aside-wrapper @click="collapsed=false">
                <slot></slot>
            </aside-wrapper>
        </el-scrollbar>
        <div class="footer">
            <div class="footer-left" @click.stop>
                <template v-if="collapsed">
                    <el-tooltip :content="versionTooltip" placement="top">
                        <el-icon style="margin: 9px 8px 9px 12px" :size="18">
                            <InfoFilled/>
                        </el-icon>
                    </el-tooltip>
                </template>
                <template v-else>
                    <el-tooltip :content="versionTooltip" placement="top">
                        <span class="version-text">{{ versionText }}</span>
                    </el-tooltip>
                </template>
            </div>
            <div class="footer-right" @click="collapsed = !collapsed">
                <el-icon style="margin: 9px 20px 9px 0" :size="22">
                    <ArrowRight v-if="collapsed"/>
                    <ArrowLeft v-else/>
                </el-icon>
            </div>
        </div>
    </el-aside>
</template>

<script>
import AsideGroup from "./AsideGroup";
import AsideWrapper from "./AsideWrapper";
import AsideItem from "./AsideItem";
import {computed} from "vue";
import {ArrowLeft, ArrowRight, InfoFilled} from '@element-plus/icons-vue'

export default {
    name: "AsideNav",
    components: {AsideItem, AsideWrapper, AsideGroup, ArrowLeft, ArrowRight, InfoFilled},
    props: {data: Object},
    data() {
        return {
            collapsed: false,
            version: '',
        }
    },
    provide() {
        return {collapsed: computed(_ =>this.collapsed), unCollapse: this.unCollapse, collapse: this.collapse}
    },
    methods: {
        collapse() {
            this.collapsed = true;
        },
        unCollapse() {
            this.collapsed = false;
        }
    },
    computed: { 
        versionText() {
            const raw = (this.version || '').replace(/\"/g, '').replace(/"/g, '').trim();
            const ts = Number(raw);
            if (ts && !isNaN(ts)) {
                const d = new Date(ts);
                return `${d.toLocaleString()}`;
            }
            return '开发版';
        },
        versionTooltip() {
            return `系统更新时间：${this.versionText}`;
        }
    },
    mounted() {
        // 生产环境下，vite 构建时会在 dist 根目录写入 version.json（时间戳）
        // 开发环境可能没有该文件，回退为"开发版"
        fetch('version.json', { cache: 'no-store' })
            .then(res => res.ok ? res.text() : Promise.reject('no version'))
            .then(text => { this.version = text; })
            .catch(() => { this.version = 'dev'; });
    }
}
</script>

<style scoped>
.el-aside {
    transition: 0.3s ease;
}
.el-aside .footer {
    font-size: 18px;
    border-top: 1px solid var(--el-border-color);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.footer-left {
    cursor: default;
}
.footer-right {
    cursor: pointer;
}
.version-text {
    display: inline-block;
    margin: 9px 12px;
    font-size: 12px;
    color: var(--el-text-color-secondary);
    white-space: nowrap;
    max-width: calc(256px - 60px);
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>